<template>
	<div class="numpad">
		<div class="row">
			<div class="btn" @click="clickNumber(1)"><div class="btn-inner">1</div></div>
			<div class="btn" @click="clickNumber(2)"><div class="btn-inner">2</div></div>
			<div class="btn" @click="clickNumber(3)"><div class="btn-inner">3</div></div>
			<div class="btn action" :class="{disabled: currentNumber === 0}" v-if="!noActions" @click="clickPercent(false)"><div class="btn-inner">-%</div></div>
		</div>
		<div class="row">
			<div class="btn" @click="clickNumber(4)"><div class="btn-inner">4</div></div>
			<div class="btn" @click="clickNumber(5)"><div class="btn-inner">5</div></div>
			<div class="btn" @click="clickNumber(6)"><div class="btn-inner">6</div></div>
			<div class="btn action" :class="{disabled: currentNumber === 0}" v-if="!noActions" @click="clickPercent(true)"><div class="btn-inner">+%</div></div>
		</div>
		<div class="row">
			<div class="btn" @click="clickNumber(7)"><div class="btn-inner">7</div></div>
			<div class="btn" @click="clickNumber(8)"><div class="btn-inner">8</div></div>
			<div class="btn" @click="clickNumber(9)"><div class="btn-inner">9</div></div>
			<div class="btn action" :class="{disabled: currentNumber === 0}" v-if="!noActions" @click="clickAbs(false)"><div class="btn-inner">-{{ currencyShortSymbol }}</div></div>
		</div>
		<div class="row" v-if="!noLastRow">
			<div class="btn" @click="clickDoubleZero()"><div class="btn-inner">00</div></div>
			<div class="btn" @click="clickNumber(0)"><div class="btn-inner">0</div></div>
			<div class="btn delete" :class="{disabled: nothingToDelete && currentNumber === 0}" @click="cancel()"><div class="btn-inner">{{ nothingToDelete ? 'C' : 'AC' }}</div></div>
			<div class="btn action" :class="{disabled: currentNumber === 0}" v-if="!noActions" @click="clickAbs(true)"><div class="btn-inner">+{{ currencyShortSymbol }}</div></div>
		</div>
	</div>
</template>

<script>
import {useCurrencyStore} from "@/shared/stores";
export default {
	setup() {
		const currencyStore = useCurrencyStore();
		return {
			currencyStore,
		}
	},
	name: "BottomNumberEditorNumpad",
	emits: ["change-number", "perform-action"],
	data() {
		return {
			currentNumber: 0,
		}
	},
	props: {
		nothingToDelete: {
			type: Boolean,
			default: true,
		},
		startingNumber: {
			type: Number,
			required: true,
		},
		noActions: {
			type: Boolean,
			default: false,
		},
		noLastRow: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		currencyShortSymbol() {
			let symbol = this.currencyStore?.currCurrency?.symbol;
			if(symbol && symbol?.length && symbol.length === 1) {
				return symbol;
			}
			return '';
		},
	},
	methods: {
		clickNumber(number) {
			this.currentNumber = this.currentNumber * 10 + number;
			this.$emit("change-number", this.currentNumber);
		},
		clickDoubleZero() {
			this.currentNumber = this.currentNumber * 100;
			this.$emit("change-number", this.currentNumber);
		},
		clickPercent(isAdd) {
			let percent = (this.currentNumber / 100) * (isAdd ? 1 : -1);
			this.$emit("perform-action", "percent", percent);
			this.currentNumber = 0;
		},
		clickAbs(isAdd) {
			let abs = this.currentNumber * (isAdd ? 1 : -1);
			this.$emit("perform-action", "abs", abs);
			this.currentNumber = 0;
		},
		cancel() {
			this.currentNumber = 0;
			this.$emit("change-number", this.startingNumber);
		},
	},
}
</script>

<style scoped lang="scss">
.numpad {
	display: flex;
	flex-direction: column;
	width: 100%;
	margin: auto;
	gap: 10px;

	.row {
		width: 100%;
		display: flex;
		justify-content: center;
		gap: 10px;

		.btn {
			background-color: var(--color-primary);
			color: var(--color-bg);
			border-radius: 26px;
			width: 80px;
			height: 80px;
			display: flex;
			justify-content: center;
			align-items: center;
			cursor: pointer;
			transition: opacity 0.2s ease-in-out;

			.btn-inner {
				background-color: var(--color-primary);
				border-radius: 20px;
				box-shadow: -3px -3px 6px rgba(255, 255, 255, 0.25), inset 3px 3px 6px rgba(0, 0, 0, 0), 3px 3px 6px rgba(0, 0, 0, 0.25), inset -3px -3px 6px rgba(255, 255, 255, 0);
				font-size: 40px;
				display: flex;
				justify-content: center;
				align-items: center;
				width: 70%;
				height: 70%;
				transition: box-shadow 0.1s ease-in-out;
				@include noSelect();
			}

			&:active .btn-inner {
				box-shadow: -3px -3px 6px rgba(255, 255, 255, 0), inset 3px 3px 6px rgba(0, 0, 0, 0.25), 3px 3px 6px rgba(0, 0, 0, 0), inset -3px -3px 6px rgba(255, 255, 255, 0.25);
			}

			&.action {
				background-color: rgb(185, 204, 236);
				color: $primary;

				.btn-inner {
					background-color: rgb(185, 204, 236);
					font-size: 36px;
					box-shadow: -3px -3px 6px rgba(255, 255, 255, 0.54), inset 3px 3px 6px rgba(0, 0, 0, 0), 3px 3px 6px rgba(0, 0, 0, 0.18), inset -3px -3px 6px rgba(255, 255, 255, 0);
				}

				&:active .btn-inner {
					box-shadow: -3px -3px 6px rgba(255, 255, 255, 0), inset 3px 3px 6px rgba(0, 0, 0, 0.18), 3px 3px 6px rgba(0, 0, 0, 0), inset -3px -3px 6px rgba(255, 255, 255, 0.54);
				}
			}

			&.delete {
				background-color: var(--color-danger);
				color: var(--color-bg);

				.btn-inner {
					background-color: var(--color-danger);
					font-size: 36px;
				}

			}

			&.disabled {
				pointer-events: none;
				opacity: 0.5;
			}

		}

	}
}
</style>